export enum RealisedFXGainOrLossType {
  RealisedFXGain = 'RealisedFXGain',
  RealisedFXLoss = 'RealisedFXLoss',
}
